import React from 'react';
import PropTypes from 'prop-types';
import SortIcon from '@mui/icons-material/Sort';
import clsx from 'clsx';

function SortableHeader({ active, order, onClick, children, className }) {
  return (
    <div
      className={`cursor-pointer select-none ${className || ''}`}
      onClick={onClick}
      role='button'
      tabIndex={0}
    >
      <span className='inline-flex items-center gap-1'>
        {children}
        <SortIcon
          className={clsx('text-base', {'rotate-180': active && order === 'ASC'})}
        />
      </span>
    </div>
  );
}

SortableHeader.propTypes = {
  active: PropTypes.bool,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  onClick: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

SortableHeader.defaultProps = {
  active: false,
  className: '',
};

export default SortableHeader;
